import AppPage from '@/components/app-page/index-noside.vue';

export default [{
  path: '/dashboard',
  name: 'Dashboard',
  component: AppPage,
  meta: {
    title: '监控平台',
  },
  children: [
    {
      path: 'index',
      name: 'Index',
      component: () => import('@/views/dashboard/index.vue'),
      meta: {
        title: '监控平台',
        style: 'brush',
        isUseEnvInfo: true,
        isUseAppInfo: true,
      },
    },
  ],
}];
